/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsEmbroideryColor
 */
export interface DigitizingMelcoDigitizingModelsEmbroideryColor {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsEmbroideryColor
     */
    color_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsEmbroideryColor
     */
    color_comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsEmbroideryColor
     */
    thread_manufacturer?: string | null;
}

export function DigitizingMelcoDigitizingModelsEmbroideryColorFromJSON(json: any): DigitizingMelcoDigitizingModelsEmbroideryColor {
    return DigitizingMelcoDigitizingModelsEmbroideryColorFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsEmbroideryColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsEmbroideryColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'color_name': !exists(json, 'color_name') ? undefined : json['color_name'],
        'color_comment': !exists(json, 'color_comment') ? undefined : json['color_comment'],
        'thread_manufacturer': !exists(json, 'thread_manufacturer') ? undefined : json['thread_manufacturer'],
    };
}

export function DigitizingMelcoDigitizingModelsEmbroideryColorToJSON(value?: DigitizingMelcoDigitizingModelsEmbroideryColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'color_name': value.color_name,
        'color_comment': value.color_comment,
        'thread_manufacturer': value.thread_manufacturer,
    };
}


